<template>
	<v-card variant="flat">
		<v-card-text>
			<div v-if="hasBusiness">
				<h2><translate>Business information</translate></h2>
				<dl class="dl-horizontal">
					<dt><translate>Business Name</translate></dt>
					<dd> {{ userBusiness.name }} </dd>

					<dt><translate>Chamber of Commerce Number</translate></dt>
					<dd> {{ userBusiness.kvk }} </dd>
				</dl>
			</div>
			<h2><translate>Personal information</translate></h2>
			<dl class="dl-horizontal">
				<dt><translate>Name</translate></dt>
				<dd> {{ userPersonal.name }} </dd>
				<dt><translate>Gender</translate></dt>
				<dd> {{ userPersonal.gender }} </dd>
				<dt><translate>Date of birth</translate></dt>
				<dd v-if="hasBirthDate">
					{{ userPersonal.birthDate }}
				</dd>
				<dt><translate>Preferred Language</translate></dt>
				<dd> {{ userPersonal.language }} </dd>
			</dl>
			<div v-if="userAddress.length">
				<h2><translate>Address information</translate></h2>
				<dl class="dl-horizontal">
					<dt><translate>Home address</translate></dt>
					<dd>
						{{ userAddress.streetAddress }} <br>
						{{ userAddress.postalCode }} {{ userAddress.city }} <br>
						{{ userAddress.country }}
					</dd>
				</dl>
			</div>
			<h2><translate>Contact information</translate></h2>
			<dl class="dl-horizontal">
				<div v-if="userTelephoneNumbers.length > 0">
					<dt><translate>Phone number</translate></dt>
					<dd
						v-for="userTelephoneNumber in userTelephoneNumbers"
						:key="userTelephoneNumber.number"
					>
						{{ userTelephoneNumber.number }}
					</dd>
				</div>
				<dt><translate>Email address</translate></dt>
				<dd>{{ userEmail }}</dd>
			</dl>
			<p>
				<a
					v-if="newWindow"
					class="btn btn-default btn-sm"
					:href="editRoute"
					target="_blank"
				>
					<span
						class="glyphicon glyphicon-pencil"
						aria-hidden="true"
					/>
					<translate>Edit information</translate>
				</a>
				<a
					v-else
					class="btn btn-default btn-sm"
					:href="editRoute"
				>
					<span
						class="glyphicon glyphicon-pencil"
						aria-hidden="true"
					/>
					<translate>Edit information</translate>
				</a>
			</p>
			<h2><translate>Newsletter</translate></h2>
			<p v-if="userNewsletter">
				<translate>You are currently subscribed to our newsletter</translate>.<br>
			</p>
			<p v-else>
				<translate>You are currently not subscribed to our newsletter</translate>.
			</p>
			<h2><translate>Bank information</translate></h2>
			<div v-if="userBank.length > 0">
				<dl
					v-for="IBAN in userBank"
					:key="IBAN"
					class="dl-horizontal"
				>
					<dt><translate>IBAN number</translate></dt>
					<dd>{{ IBAN }}</dd>
				</dl>
			</div>
			<p v-else>
				<translate>There is no known bank information for your account</translate>.
			</p>
		</v-card-text>
	</v-card>
</template>

<script>
import RouteTranslator from '../../mixins/RouteTranslator';
export default {
	name: 'UserDetails',
	mixins: [RouteTranslator, ],
	props: {
		userBusiness: {
			type: Object,
			required: true,
		},
		userPersonal: {
			type: Object,
			required: true,
		},
		userAddress: {
			type: Object,
			required: false,
			/**
			 * @returns {object}
			 */
			default: function () {
				return {
				};
			},
		},
		userEmail: {
			type: String,
			required: true,
		},
		userTelephoneNumbers: {
			type: Array,
			required: true,
		},
		userBank: {
			type: Array,
			required: true,
		},
		userNewsletter: {
			type: Number,
			required: true,
		},
		newWindow: {
			type: Boolean,
			required: false,
			default: false
		}
	},

	data () {
		return {
			editRoute: '/dashboard/profile/edit',
		};
	},

	computed: {
		/**
		 * @returns {boolean}
		 */
		hasBusiness () {
			return this.userBusiness.exists === '1';
		},

		/**
		 * @returns {boolean}
		 */
		hasBirthDate () {
			return this.userPersonal.BirthDate !== null;
		},
	},

	created () {
		this.translateRoute('/dashboard/profile/edit').then((translatedPath) => {
			this.editRoute = translatedPath;
		});
	},


};
</script>
